import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import PieChartView  from 'report/PieChartView.js';
import listService from 'ListService';


class ControlPieChartFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.mainLength = '7';
        attributes.styleBGColorText = '#FFFFFF';
        attributes.fontFamily =  listService.accountSettings.DefaultFontSelected || "verdana";;
        attributes.fontSize = '10';
        attributes.textWeight = '';
        attributes.textStyle  = '';
        attributes.showPieLegend = false;
        attributes.showPieLabel = false;

        attributes.pieText0 = 'Product A';
        attributes.pieText1 = 'Product B';
        attributes.pieText2 = 'Product C';
        attributes.pieText3 = 'Product D';
        attributes.pieText4 = 'Product E';
        attributes.pieText5 = 'Product F';
        attributes.pieText6 = 'Product G';
        attributes.pieText7 = 'Product H';
        
        attributes.additiveDynamicFilter = 'true'; 
        attributes.respectDynamicFilter = 'true'; 
        attributes.setDynamicFilter = 'true'; 
        
        attributes.Columns = { Column: [{ id:'0', Properties: {
            usesExpression: "false",
            formatoption: "",
            fieldId: "",
            width: "150",
            format: "none",
            caption: "",
            sortType: "none",
            visible: "true",
            setDynamicFilter: "false",
            align: "left",
            aggregation: "group",
            fieldDataType: "",
            sortOrder: "0"
        }},
            { id:'1', Properties: {
                usesExpression:"false",
                formatoption:"",
                fieldId:"",
                width:"150",
                format:"none",
                caption:"",
                sortType:"none",
                visible:"true",
                setDynamicFilter:"false",
                align:"left",
                aggregation:"count",
                fieldDataType:"",
                sortOrder:"0"
            }}
        ]};
        attributes.resizePadding = 2;

        attributes.Property = [{_id: 'sliceColors', Item: [ {_value:'E48701'}, {_value:'A5BC4E'}, {_value:'1B95D9'}, {_value:'CACA9E'}, {_value:'6693B0'}, {_value:'F05E27'}, {_value:'86D1E4'}, {_value:'E4F9A0'} ]},
            {_id: 'sliceValues', Item: [{_value:''}, {_value:''}, {_value:''}, {_value:''}, {_value:''}, {_value:''}, {_value:''}, {_value:''} ]}];
		attributes.minWidth = 100;
		attributes.minHeight = 150;
        attributes.lowestHeight = 150;
        attributes.fontFamily =  listService.accountSettings.DefaultFontSelected || "verdana";;
		attributes.fontSize = '10';
		attributes.textWeight = '';
		attributes.textStyle  = '';
        attributes.pieLabelsPositions = 'inside';
        
        const view = new PieChartView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlPieChartFactory = new ControlPieChartFactory();

export default controlPieChartFactory;